import * as Sentry from '@sentry/vue';

const WRITE_METHODS = ['post', 'put', 'patch', 'delete'];

function isWrite(reason) {
  const method = reason && reason.config && reason.config.method;
  return !!method && WRITE_METHODS.includes(method.toLowerCase());
}

/**
 * Reports promise rejections that no caller handled.
 *
 * Most write calls in the app are `api.foo(...).then(...)` with no `.catch()`.
 * When one of those fails the rejection goes nowhere: the user sees the UI
 * carry on as if the save worked (this is exactly how the client-location save
 * silently discarded every edit). Handling it here means a swallowed failure is
 * impossible by default, without every call site having to remember - and it
 * only fires when nobody handled the error, so components that do their own
 * error handling are unaffected.
 */
export function handleUnhandledRejection(
  event,
  { notify = window.alert } = {}
) {
  const { reason } = event;
  // The 401/404 interceptors return a never-settling promise deliberately, so
  // anything arriving here is a real unhandled failure.
  Sentry.captureException(reason, {
    tags: { failure: 'unhandled_rejection' },
  });

  if (isWrite(reason)) {
    notify(
      'Something went wrong and your change may not have been saved. Reload the page and check before trying again.'
    );
  }
}

export function installUnhandledRejectionHandler() {
  window.addEventListener('unhandledrejection', handleUnhandledRejection);
}
